// loading.ts
import { Modal, Spin } from "ant-design-vue";
import { h } from "vue";

export const showLoading = () => {
  Modal.destroyAll();
  return Modal.confirm({
    icon: null,
    content: h(Spin, {
      size: "large",
    }),
    closable: false,
    maskClosable: false,
    footer: null,
    width: "auto",
    centered: true,
    wrapClassName: "custom-loading-modal",
  });
};

export const hideLoading = () => {
  Modal.destroyAll();
};
